import React from 'react'

import Popup from '@/shared/components/layers/Popup/Popup'
import TableView from '@/shared/components/organism/TableView/TableView'
import { TopUsersInterface } from '../../TopEmployeesCompany/useTopEmployeesCompany'

import css from './TopUsers.module.css'
import { Input } from '@/shared/components/common/Input/Input'
import { PlanTypeInterface } from '@/entities/Plan/model/plan.types'
import { Select } from '@/shared/components/common/Select/Select'

type TopUsersPopupProps = {
  title: string
  open: boolean
  loading: boolean
  onClose: () => void
  data: TopUsersInterface[]

  planTypes: PlanTypeInterface[]
  isPeriod: boolean
  setIsPeriod?: (p: boolean) => void
  typeId: number
  setTypeId: (p: number) => void
}

const TopUsersPopup: React.FC<TopUsersPopupProps> = ({
  open,
  onClose,
  loading,
  title,
  data,

  planTypes,
  isPeriod, setIsPeriod,
  typeId, setTypeId
}) => {
  return (
    <Popup 
      open={open}
      onClose={onClose} 
      title={title}
      size='xl' 
      fullHeight
    >
      <div className={css.settings}>
          <Input
            type='checkbox'
            checked={isPeriod}
            label='За все время'
            onChange={e => setIsPeriod && setIsPeriod(e.target.checked)}
          />

          <Select
            value={String(typeId)}
            onChange={val => setTypeId(Number(val))}
            options={planTypes.filter(pt => pt.code.includes('EMPLOYEE')).map(pt => ({
              value: String(pt.id),
              label: pt.name
            }))}
          />
      </div>

      

      <TableView loading={loading} data={data.filter(i => i.percent > 0).map(u => ({
        'Место': u.place,
        'Имя': u.fullName,
        'Процент выполнения': u.percent
      }))}/>
    </Popup>
  )
}

export default TopUsersPopup